
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-tools/error-codes",
      function () {
        return require("private-next-pages/developer-tools/error-codes.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-tools/error-codes"])
      });
    }
  